import { 
  getCounts as apiGetCounts,
  getMonthlyNewUsers as apiGetMonthlyNewUsers,
  getMonthlyNewHouses as apiGetMonthlyNewHouses,
  getDashboardStats as apiGetDashboardStats,
  getUserStats as apiGetUserStats,
  getHouseStats as apiGetHouseStats,
  exportStats as apiExportStats
} from '@/api/stats'

const state = {
  counts: null,
  monthlyNewUsers: null,
  monthlyNewHouses: null,
  dashboardStats: null,
  userStats: null,
  houseStats: null,
  loading: false
}

const getters = {
  counts: state => state.counts,
  monthlyNewUsers: state => state.monthlyNewUsers,
  monthlyNewHouses: state => state.monthlyNewHouses,
  dashboardStats: state => state.dashboardStats,
  userStats: state => state.userStats,
  houseStats: state => state.houseStats,
  loading: state => state.loading
}

const mutations = {
  SET_COUNTS(state, counts) {
    state.counts = counts
  },
  SET_MONTHLY_NEW_USERS(state, monthlyNewUsers) {
    state.monthlyNewUsers = monthlyNewUsers
  },
  SET_MONTHLY_NEW_HOUSES(state, monthlyNewHouses) {
    state.monthlyNewHouses = monthlyNewHouses
  },
  SET_DASHBOARD_STATS(state, stats) {
    state.dashboardStats = stats
  },
  SET_USER_STATS(state, stats) {
    state.userStats = stats
  },
  SET_HOUSE_STATS(state, stats) {
    state.houseStats = stats
  },
  SET_LOADING(state, loading) {
    state.loading = loading
  }
}

const actions = {
  async fetchCounts({ commit }) {
    commit('SET_LOADING', true)
    try {
      const response = await apiGetCounts()
      // 根据API响应格式，实际数据在response.data中
      commit('SET_COUNTS', response.data)
      return response
    } catch (error) {
      console.error('获取统计总数失败:', error)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },
  
  async fetchMonthlyNewUsers({ commit }) {
    try {
      const response = await apiGetMonthlyNewUsers()
      commit('SET_MONTHLY_NEW_USERS', response.data)
      return response
    } catch (error) {
      console.error('获取每月新增用户数失败:', error)
      throw error
    }
  },
  
  async fetchMonthlyNewHouses({ commit }) {
    try {
      const response = await apiGetMonthlyNewHouses()
      commit('SET_MONTHLY_NEW_HOUSES', response.data)
      return response
    } catch (error) {
      console.error('获取每月新增房源数失败:', error)
      throw error
    }
  },
  
  async fetchDashboardStats({ commit }) {
    commit('SET_LOADING', true)
    try {
      const response = await apiGetDashboardStats()
      commit('SET_DASHBOARD_STATS', response.data)
      return response
    } catch (error) {
      console.error('获取仪表板统计失败:', error)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },
  
  async fetchUserStats({ commit }, params = {}) {
    try {
      const response = await apiGetUserStats(params)
      commit('SET_USER_STATS', response.data)
      return response
    } catch (error) {
      console.error('获取用户统计失败:', error)
      throw error
    }
  },
  
  async fetchHouseStats({ commit }, params = {}) {
    try {
      const response = await apiGetHouseStats(params)
      commit('SET_HOUSE_STATS', response.data)
      return response
    } catch (error) {
      console.error('获取房源统计失败:', error)
      throw error
    }
  },
  
  async exportStats(_, params) {
    try {
      const response = await apiExportStats(params)
      return response
    } catch (error) {
      console.error('导出统计报表失败:', error)
      throw error
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}